import { Close } from '@carbon/icons-react';
import { Button, Clickable } from '@routable/gross-ds';
import clsx from 'clsx';
import _get from 'lodash/get';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { BaseHint, Image } from 'components';
import { individualPartnershipContactFormFields } from 'constants/formFields';
import { Intent } from 'constants/ui';
import { getStaticResourceFullPath } from 'helpers/assets';
import { convertToLowerCase } from 'helpers/stringHelpers';
export const ImportedContactFromLedgerForPersonalTypePartnership = ({ className, formName, importedContact, partnershipType, ledger, }) => {
    const image = getStaticResourceFullPath(`/images/_global/integrations/${convertToLowerCase(ledger.application)}.svg`);
    const dispatch = useDispatch();
    const [isDismissed, setIsDismissed] = useState(false);
    const formValues = useSelector(getFormValues(formName));
    const firstName = _get(formValues, individualPartnershipContactFormFields.FIRST_NAME);
    const lastName = _get(formValues, individualPartnershipContactFormFields.LAST_NAME);
    const email = _get(formValues, individualPartnershipContactFormFields.EMAIL);
    const phoneNumber = _get(formValues, individualPartnershipContactFormFields.PHONE_NUMBER);
    useEffect(() => {
        if (isDismissed) {
            return;
        }
        if (importedContact.firstName && importedContact.firstName !== firstName) {
            setIsDismissed(true);
        }
        else if (importedContact.lastName && importedContact.lastName !== lastName) {
            setIsDismissed(true);
        }
        else if (importedContact.email && importedContact.email !== email) {
            setIsDismissed(true);
        }
        else if (importedContact.phoneNumber && importedContact.phoneNumber !== phoneNumber) {
            setIsDismissed(true);
        }
    }, [firstName, lastName, email, phoneNumber, importedContact, formValues, isDismissed]);
    const onClearContact = () => {
        dispatch(change(formName, individualPartnershipContactFormFields.FIRST_NAME, ''));
        dispatch(change(formName, individualPartnershipContactFormFields.LAST_NAME, ''));
        dispatch(change(formName, individualPartnershipContactFormFields.EMAIL, ''));
        dispatch(change(formName, individualPartnershipContactFormFields.PHONE_NUMBER, ''));
        setIsDismissed(true);
    };
    if (isDismissed) {
        return null;
    }
    return (React.createElement("div", { className: clsx(className) },
        React.createElement(BaseHint, { bodyClassName: "w-full", hideIcon: true, intent: Intent.INFO, title: React.createElement("div", { className: "w-full flex gap-4" },
                React.createElement(Image, { alt: ledger.name, className: "mt-1", src: image, style: {
                        height: 16,
                        width: 16,
                    } }),
                React.createElement("div", { className: "flex flex-[20] flex-col" },
                    React.createElement("span", { className: "text-black text-sm bold" }, `Contact information pre-filled from ${ledger.name}`),
                    React.createElement("span", { className: "mt-2" }, `There was a contact associated with this ${partnershipType} on ${ledger.name} that has been added.`),
                    React.createElement(Clickable, { onClick: onClearContact, variant: "black" }, "Clear contact")),
                React.createElement(Button, { "data-testid": "imported-contact-hint-close-button", onPress: () => setIsDismissed(true), size: "small", variant: "floating" },
                    React.createElement(Close, { title: "Close" }))), titleProps: { className: 'w-full' } })));
};
